<template>
  <div class="pl-swipeable-table" :class="{ 'elevation-1': outerBorder }">
    <data-table
      ref="table"
      :dragscroll="true"
      @dragscrollend="scrollEnd"
      @dragscrollclick="scrollClick"
      @dragscrollmove="updateSyncedScrollBody"
      @headerPositionChanged="updateVerticalPositions"
      @tableContentWidthChanged="updateTableContentWidth"
      hide-actions
      :class="['pl-table', 'pl-table_active', customWidth ? 'pl-table_fixed' : '']"
      :headers="headers"
      :items="items"
      :no-data-text="noDataText"
      :custom-headers="customHeaders"
      :sticky-header="stickyHeader"
      :sticky-first-column="stickyFirstColumn"
      :loading="loading"
    >
      <template slot="headers">
        <slot name="header"></slot>
      </template>
      <template slot="items" slot-scope="props">
        <slot name="rows" :item="props.item" :index="props.index"> </slot>
      </template>
    </data-table>
    <div class="pl-swipeable-table_button-container">
      <v-btn
        :absolute="true"
        :disabled="leftButtonDisabled"
        icon
        class="pl-swipeable-table_button pl-swipeable-table_button__back"
        @click="onBackButtonClick"
      >
        <v-icon> chevron_left </v-icon>
      </v-btn>
      <v-btn
        :absolute="true"
        :disabled="rightButtonDisabled"
        icon
        class="pl-swipeable-table_button pl-swipeable-table_button__forward"
        @click="onForwardButtonClick"
      >
        <v-icon> chevron_right </v-icon>
      </v-btn>
    </div>

    <div v-if="!hidePagination" class="text-xs-center white pt-3 pb-3">
      <v-layout justify-center>
        <v-flex xs6 class="mt-3">
          <div>
            <v-pagination
              ref="pagination"
              v-model="currentPage"
              :length="Math.ceil(count / itemsPerPage) || 1"
              total-visible="10"
              @input="paginationChange"
            ></v-pagination>
          </div>
        </v-flex>

        <v-flex xs2 class="ml-5">
          <v-select
            v-model="itemsPerPage"
            :items="itemsPerPageItems"
            label="Количество отображаемых записей"
            single-line
            class="pl-select"
            @input="paginationChange"
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import DataTable from '@/components/DataTable/DataTable'

export default {
  name: 'SwipeableTable',
  components: {
    'data-table': DataTable,
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    headers: {
      type: Array,
      required: true,
    },
    customHeaders: {
      type: Boolean,
      default: false,
    },
    customWidth: {
      type: Boolean,
      default: false,
    },
    stickyHeader: {
      type: Boolean,
      default: false,
    },
    stickyFirstColumn: {
      type: Boolean,
      default: false,
    },
    outerBorder: {
      type: Boolean,
      default: false,
    },
    noDataText: {
      type: String,
      default: Vue.config.localization.ru.noDataText,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hidePagination: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
    notChangeRoute: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      horizontalScrollPosition: 0,
      actualTableContentWidth: 0,
      visibleWidth: 0,
      dragEnd: 0,
      stickyColumnHead: null,
      stickyColumnHeadXOffset: 0,
      stickyColumnHeadYOffset: 0,
      stickyColumnCells: null,
      tableHeads: [],
      currentPage: 1,
      itemsPerPageItems: [25, 50, 100, 200],
      itemsPerPage: 25,
      isDataLoaded: false,
    }
  },
  methods: {
    paginationChange(page) {
      if (!this.$props.notChangeRoute) {
        if (this.currentPage !== parseInt(this.$route.query.offset)) {
          this.$router.replace({ ...this.$route.hash, query: { ...this.$route.query, offset: this.currentPage } })
        }
        if (this.itemsPerPage !== parseInt(this.$route.query.items)) {
          this.$router.replace({ ...this.$route.hash, query: { ...this.$route.query, items: this.itemsPerPage } })
        }
      }
      this.$emit('load-data', {
        offset: (this.currentPage - 1) * this.itemsPerPage,
        limit: parseInt(this.itemsPerPage),
      })
    },
    scrollEnd(e, ts) {
      this.dragEnd = ts
    },
    scrollClick(e, ts) {
      if (Math.abs(ts - this.dragEnd) < 100 || this.loading) {
        e.stopPropagation()
      }
    },
    updateSyncedScrollBody(e) {
      if (this.scrollableContainer !== null) {
        this.scrollableContainer.scrollLeft += e.deltaX
      }
    },
    updateVerticalPositions(e) {
      if (this.stickyHeader && this.stickyFirstColumn) {
        this.buttonContainer.style.transform = `translate3d(0, ${e}px, 0)`
        this.tableHeads.forEach(head => {
          head.style.transform = `translate3d(0, ${e}px, 0)`
          head.style.transition = 'transform 0s'
        })
        this.stickyColumnHeadYOffset = e
        this.stickyColumnHead.style.transform = `translate3d(${this.stickyColumnHeadXOffset}px, ${this.stickyColumnHeadYOffset}px, 0)`
      } else if (this.stickyHeader && !this.stickyFirstColumn) {
        this.buttonContainer.style.transform = `translate3d(0, ${e}px, 0)`
        this.tableHeads.style.transform = `translate3d(0, ${e}px, 0)`
        this.tableHeads.style.transition = 'transform 0s'
      } else {
        this.buttonContainer.style.transform = 'translate3d(0)'
        this.tableHeads.forEach(head => {
          head.style.transform = 'translate3d(0)'
          head.style.transition = 'transform 0s'
        })
      }
    },
    updateHorizontalPositions(e) {
      this.horizontalScrollPosition = e.target.scrollLeft

      if (this.stickyFirstColumn) {
        this.stickyColumnHeadXOffset = this.horizontalScrollPosition
        this.stickyColumnHead.style.transform = `translate3d(${this.stickyColumnHeadXOffset}px, ${this.stickyColumnHeadYOffset}px, 0)`

        this.stickyColumnCells.forEach(cell => {
          cell.style.transform = `translate3d(${this.horizontalScrollPosition}px, 0, 0)`
        })
      }
    },
    updateTableContentWidth(e) {
      this.actualTableContentWidth = e
    },
    updateVisibleWidth(e) {
      this.visibleWidth = e
    },
    recalcVisibleWidth() {
      this.updateVisibleWidth(this.$el.clientWidth)
    },
    onBackButtonClick() {
      this.animate({
        timing: this.timingFunc,
        duration: 255,
        draw: progress => this.updateSyncedScrollBody({ deltaX: -(50 * progress) }),
      })
    },
    onForwardButtonClick() {
      this.animate({
        timing: this.timingFunc,
        duration: 255,
        draw: progress => this.updateSyncedScrollBody({ deltaX: 50 * progress }),
      })
    },
    timingFunc(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
    },
    animate(options) {
      const start = performance.now()
      requestAnimationFrame(function animate(time) {
        // timeFraction от 0 до 1
        let timeFraction = (time - start) / options.duration
        if (timeFraction > 1) timeFraction = 1
        // текущее состояние анимации
        const progress = options.timing(timeFraction)
        options.draw(progress)
        if (timeFraction < 1) {
          requestAnimationFrame(animate)
        }
      })
    },
    initStickyFirstColumn() {
      this.stickyColumnHead = this.$el.querySelector('th')
      this.stickyColumnHead.classList.add('sticky-column-head')
      this.stickyColumnCells = this.$el.querySelectorAll('td:first-of-type')
      this.stickyColumnCells.forEach(cell => cell.classList.add('sticky-column-cell'))
    },
    initStickyHeader() {
      this.tableHeads = this.stickyFirstColumn ? this.$el.querySelectorAll('th') : this.$el.querySelector('thead')
    },
  },
  computed: {
    leftButtonDisabled() {
      return !this.noScroll || this.horizontalScrollPosition <= 0
    },
    rightButtonDisabled() {
      return !this.noScroll || this.horizontalScrollPosition + this.visibleWidth >= this.actualTableContentWidth
    },
    noScroll() {
      if (this.scrollableContainer) {
        return this.scrollableContainer.clientWidth < this.actualTableContentWidth
      } else {
        return true
      }
    },
  },
  mounted() {
    this.$setLoad(true)
    this.rendered = false
    window.addEventListener('resize', this.recalcVisibleWidth)
    this.scrollableContainer = null
    this.buttonContainer = this.$el.querySelector('.pl-swipeable-table_button-container')
    if (this.stickyFirstColumn) this.initStickyFirstColumn()
    if (this.stickyHeader) this.initStickyHeader()
    this.recalcVisibleWidth()
    if (this.$route.query.offset) this.currentPage = parseInt(this.$route.query.offset)
    if (this.$route.query.items) this.itemsPerPage = parseInt(this.$route.query.items)
    this.paginationChange(true)
    this.$setLoad(false)
  },
  updated() {
    if (!this.rendered) {
      if (this.$el && this.$refs.table && this.$refs.table.$el) {
        const rect = this.$el.getBoundingClientRect()
        if (rect.width > 0) {
          this.buttonContainer = this.$el.querySelector('.pl-swipeable-table_button-container')
          this.scrollableContainer = this.$refs.table.$el.querySelector('.v-table__overflow')
          this.scrollableContainer.addEventListener('scroll', this.updateHorizontalPositions)
          this.recalcVisibleWidth()
          this.rendered = true
        }
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.recalcVisibleWidth)
    if (this.scrollableContainer !== null) {
      this.scrollableContainer.removeEventListener('scroll', this.updateHorizontalPositions)
    }
  },
}
</script>
